import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { Source } from 'react-map-gl';
import { Layer, LayerBand, LAYER_ORDER } from '../ordered-layer';
import { createMapSourceAtom } from '../atoms';
import { MapUserConfigAtom } from '../types';

const DrillingRigLayer = ({
  mapConfigAtom,
}: {
  mapConfigAtom: MapUserConfigAtom;
}) => {
  const drillingRigsSourceAtom = useMemo(
    () => createMapSourceAtom('drillingRigs'),
    []
  );
  const drillingRigsSource = useAtomValue(drillingRigsSourceAtom);
  const mapConfig = useAtomValue(mapConfigAtom);

  if (!drillingRigsSource) {
    return null;
  }

  return (
    <LayerBand band={LAYER_ORDER.drillingRigs}>
      <Source id="drilling-rigs" type="vector" url={drillingRigsSource}>
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.horizontalDrilling && (
            <Layer
              id="drilling-rigs-horizontal-drilling"
              type="symbol"
              source-layer="horizontal-drilling"
              layout={{
                'icon-image': 'horizontal-drilling',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.horizontalDown && (
            <Layer
              id="drilling-rigs-horizontal-down"
              type="symbol"
              source-layer="horizontal-down"
              layout={{
                'icon-image': 'horizontal-down',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.horizontalNotReporting && (
            <Layer
              id="drilling-rigs-horizontal-not-reporting"
              type="symbol"
              source-layer="horizontal-not-reporting"
              layout={{
                'icon-image': 'horizontal-not-reporting',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.verticalDrilling && (
            <Layer
              id="drilling-rigs-vertical-drilling"
              type="symbol"
              source-layer="vertical-drilling"
              layout={{
                'icon-image': 'vertical-drilling',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.verticalDown && (
            <Layer
              id="drilling-rigs-vertical-down"
              type="symbol"
              source-layer="vertical-down"
              layout={{
                'icon-image': 'vertical-down',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.verticalNotReporting && (
            <Layer
              id="drilling-rigs-vertical-not-reporting"
              type="symbol"
              source-layer="vertical-not-reporting"
              layout={{
                'icon-image': 'vertical-not-reporting',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.verticalNotTracking && (
            <Layer
              id="drilling-rigs-vertical-not-tracking"
              type="symbol"
              source-layer="vertical-not-tracking"
              layout={{
                'icon-image': 'vertical-not-tracking',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.verticalUnreportedStatus && (
            <Layer
              id="drilling-rigs-vertical-unreported-status"
              type="symbol"
              source-layer="vertical-unreported-status"
              layout={{
                'icon-image': 'vertical-unreported-status',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
        {mapConfig?.drillingRigs?.checked &&
          mapConfig?.drillingRigs?.options?.verticalNotTracking && (
            <Layer
              id="drilling-rigs-vertical-not-tracking"
              type="symbol"
              source-layer="vertical-not-tracking"
              layout={{
                'icon-image': 'vertical-not-tracking',
                'icon-size': 1.2,
                'icon-allow-overlap': true,
                'icon-ignore-placement': true,
              }}
            />
          )}
      </Source>
    </LayerBand>
  );
};

export { DrillingRigLayer };
